export default __webpack_public_path__ + "media/images/icons/thumbs-up-218a752287165c207091ebd7177bd1f4.svg";